module.exports = __webpack_public_path__ + "static/media/smart_watch_scale.af3d17ef.png";